// Display helpers for the workload pages: token counts, run times and durations, and the
// names of agent CLIs, in the active language (i18n/format.ts).
import { formatClock, formatCompact, formatDayMonth, formatHourMinute, formatUnit, formatUsd, messages } from "../i18n";

/** 4210 → "4.2k", 980 → "980". */
export const kTokens = formatCompact;

export const hourMinute = formatHourMinute;

export const clockTime = formatClock;

/** "Today 19:42", "Yesterday 21:10", "2 Oct 11:47". */
export function dayTime(ms: number, now = Date.now()): string {
  const date = new Date(ms);
  const today = new Date(now);
  const yesterday = new Date(now);
  yesterday.setDate(today.getDate() - 1);
  const same = (a: Date, b: Date) => a.toDateString() === b.toDateString();
  const { common } = messages();
  const day = same(date, today) ? common.today : same(date, yesterday) ? common.yesterday : formatDayMonth(date);
  return `${day} ${hourMinute(ms)}`;
}

/** "6m 08s", "48s", "1h 02m"; a dash before the run started. */
export function elapsed(startMs: number | null | undefined, endMs: number | null | undefined, now = Date.now()): string {
  if (startMs == null) return "—";
  const s = Math.max(0, Math.round(((endMs ?? now) - startMs) / 1000));
  if (s < 60) return formatUnit(s, "second");
  if (s < 3600) return `${formatUnit(Math.floor(s / 60), "minute")} ${formatUnit(s % 60, "second", "narrow", true)}`;
  return `${formatUnit(Math.floor(s / 3600), "hour")} ${formatUnit(Math.floor((s % 3600) / 60), "minute", "narrow", true)}`;
}

const CLI: Record<string, string> = { claude: "Claude Code", cursor: "Cursor", codex: "Codex" };

export function cliName(provider: string): string {
  return CLI[provider] ?? provider;
}

export function usd(n: number | null | undefined): string {
  return n == null ? "—" : formatUsd(n);
}

/** Bytes as whole GiB, as a number (for meters). */
export function gibCount(bytes: number): number {
  return Math.round((bytes / 1024 ** 3) * 10) / 10;
}
